import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = {
  key: 0,
  class: "row m-auto"
}
const _hoisted_4 = { class: "col-12 px-0 pt-4" }
const _hoisted_5 = { class: "row px-2 text-center" }
const _hoisted_6 = { class: "col-sm-12 col-md-4" }
const _hoisted_7 = { class: "col-sm-12 col-md-4" }
const _hoisted_8 = { class: "col-sm-12 col-md-4" }
const _hoisted_9 = {
  key: 1,
  class: "loading-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Visit Stats", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Pending", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.pending_count), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Scheduled", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.scheduled_count), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Completed", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.completed_count), 1)
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}